import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FiledsCard from "../../Components/FiledsCard/FiledsCard";
import FileUpload from "../FileUploadBox/FileUpload/FileUpload";
import "./DocumentuploadSection.scss";
import { updateFormData } from "../../../Store/FormDataReducer/FormFieldFunctions";
import { deepEqual } from "../../custom_hooks/deepEqual";

const DocumentuploadSection = ({
  LoadForm,
  data,
  allFieldsData,
  fielddata,
  TypeOfPortal,
  formkey = "",
  formReference = {},
  values,
}) => {
  const [files, setFiles] = useState({});
  const dispatch = useDispatch();
  const upadteValueForm = (values) => {
    if (formReference?.current?.GetFileValues) {
      formReference?.current.GetFileValues(values);
    } else if (formReference?.current && values) {
      formReference?.current["Documents"]?.updateForm(values);
    }
  };

  useEffect(() => {
    updateFormData(dispatch, formkey, "Files", files);
    upadteValueForm(files);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);
  // Initialize 'files' state based on 'values' and 'data' props
  useEffect(() => {
    console.log(values, data, "infanitelooooop");
    if (values && data.length > 0) {
      // console.log("Initializing files from values and data");
      const initialFiles = data.reduce((accumulator, item) => {
        accumulator[item.name] = values[item.name] || "";
        return accumulator;
      }, {});
      if (!deepEqual(files, initialFiles)) {
        setFiles(initialFiles);
      }
    }
  }, [values, data]);
  return (
    <div>
      <div className="container">
        <FiledsCard LoadForm={LoadForm}>
          {data.length &&
            data?.map((e) => {
              return (
                <FileUpload
                  LoadForm={LoadForm}
                  TypeOfPortal={TypeOfPortal}
                  title="Doc"
                  allFieldsData={files}
                  e={e}
                  sendFile={(link) => {
                    setFiles({
                      ...files,
                      [e.name]: link,
                    });
                  }}
                />
              );
            })}
        </FiledsCard>
      </div>
    </div>
  );
};

export default React.memo(DocumentuploadSection);
